import { render } from "./VideoTools.vue?vue&type=template&id=28c5a38c&scoped=true"
import script from "./VideoTools.vue?vue&type=script&lang=ts"
export * from "./VideoTools.vue?vue&type=script&lang=ts"

import "./VideoTools.vue?vue&type=style&index=0&id=28c5a38c&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-28c5a38c"

export default script